import React, { useEffect, useRef } from 'react';
import { createBrowserRouter, RouterProvider, Outlet, Navigate, useLocation, ScrollRestoration } from 'react-router-dom';
import Header from './components/Header';
import SchedulePage from './pages/SchedulePage';
import RankingPage from './pages/RankingPage';
import PrivacyPage from './pages/PrivacyPage';
import OshiTop3Page from './pages/OshiTop3Page';
import OshiSharePage from './pages/OshiSharePage';
import Footer from './components/Footer';
import './App.css';

// 推しTop3専用レイアウト（ヘッダーのみ、フッター・バナーなし）
function OshiLayout() {
  return (
    <div className="App">
      <Header />
      <Outlet />
    </div>
  );
}

// レイアウトコンポーネント
function Layout() {
  const location = useLocation();
  const mainRef = useRef(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    // ハッシュがない場合はトップにスクロール
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
    
    // 初回レンダリング時はアニメーションをスキップ
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // ページ遷移時のフェードインアニメーション
    if (mainRef.current) {
      // 一旦フェードインクラスを削除
      mainRef.current.classList.remove('fade-in');
      
      // 次のフレームでフェードインクラスを追加（アニメーションを再トリガー）
      requestAnimationFrame(() => {
        if (mainRef.current) {
          mainRef.current.classList.add('fade-in');
        }
      });
    }
  }, [location.pathname]);

  return (
    <div className="App">
      <ScrollRestoration />
      <Header />
      <main ref={mainRef} className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

// ルーター設定（future flagsを有効化）
const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <SchedulePage />
      },
      {
        path: 'ranking',
        element: <RankingPage />
      },
      {
        path: 'privacy',
        element: <PrivacyPage />
      },
      {
        path: '*',
        element: <Navigate to="/" replace />
      }
    ]
  },
  {
    path: '/oshi3',
    element: <OshiLayout />,
    children: [
      {
        index: true,
        element: <OshiTop3Page />
      },
      {
        path: 'share',
        element: <OshiSharePage />
      }
    ]
  }
], {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
});

function App() {
  return <RouterProvider router={router} />;
}

export default App;
